import IComponent from "components/commons/IComponent";
import "./PhotoFrame.scoped.css";
class PhotoFrame extends IComponent {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  componentWillUnmount() {}
  render() {
    return (
      <div className="photoFrame">
        {(this.props.urlList || []).map((i, j) => {
          return (
            <span key={`photo_${j}`}>
              <a href={i} target="#">
                <img
                  className="photo"
                  src={i}
                  alt=""
                  style={{ padding: "20px", pointerEvents: "none" }}
                />
                <button
                  className="button zoom_in_white_24dp"
                  style={{ cursor: "pointer" }}
                />
              </a>
            </span>
          );
        })}
      </div>
    );
  }
}

export default PhotoFrame;
